<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const viewOcrResource = new resource('configurations/ocr')

export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/configuration/',
                    menuLabel: 'Idenfo Engine',
                    name: 'idenfo-engine',
                    permission: ['idenfo-engine'],
                },
                {
                    anchorLink: '/configuration/screening-data/',
                    menuLabel: 'Screening Data',
                    name: 'client-black-list',
                    permission: ['client-black-list'],
                },
                {
                    anchorLink: '/configuration/form-builder/',
                    menuLabel: 'Form Builder',
                    name: 'form-builder-setup-profile',
                    permission: ['form-builder'],
                },
                // {
                //     anchorLink: '/configuration/simulate/',
                //     menuLabel: 'Simulate',
                //     name: 'initiate-simulation-process',
                //     permission: ['initiate-simulation-process'],
                // },
                {
                    anchorLink: '/configuration/on-boarding-configuration/',
                    menuLabel: 'On Boarding Configuration',
                    name: 'on-boarding-configuration',
                    permission: ['ocr'],
                },
                {
                    anchorLink: '/configuration/branding/',
                    menuLabel: 'Branding',
                    name: 'branding',
                    permission: ['branding'],
                },
            ],
            query: {
                dataSegmentId: localStorage.getItem('dataSegmentId'),
            },
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > computed

    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getOcrData()
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getOcrData()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getOcrData() {
            if (this.dataSegmentId) {
                this.query.dataSegmentId = this.dataSegmentId
            }
            let { data } = await viewOcrResource.list(this.query)
            this.$store.commit('setConfigurationOcrData', data.data)
        },
    }, // End of Component > methods
} // End of export default
</script>
